import { gql } from "@apollo/client";

export const WHEN_BENEFITS_QUERY = gql`
  query WhenBenefits($uid: String) {
    whenBenefits(uid: $uid) {
      caseId
      companyId
      benefit {
        status
        hasBenefit
        benefitTier
        amount
        releasedDate
        detail {
          total
          amountSpent
          amountPending
          amountRemaining
          amountForfeited
        }
        distributionType
        unusedFunds
        monthsToAllocate
        reimbursementRequests {
          reimbursementRequestId
          amount
          status
          userId
          approvedAmount
          coverageMonths
          createdAt
          updatedAt
          files {
            name
            type
            path
          }
        }
        months {
          month
          amount
          deadline
          requested
          reimbursedAmount
          expired
          returned
        }
        perMonthDeadline {
          dayOfMonth
          monthsAfter
        }
        monthlyBenefitInitialGracePeriod {
          dayOfMonth
          monthsAfter
        }
      }
    }
  }
`;
